
export const TILE_CLICKED = 'TILE_CLICKED';
export const HOVER_TILE = 'HOVER_TILE';
export const UNHOVER_TILE = 'UNHOVER_TILE';
export const SET_EDITOR_TYPE = 'SET_EDITOR_TYPE';
export const MAP_NAME_CHANGED = 'MAP_NAME_CHANGED';
export const MAP_CODE_ENTERED = 'MAP_CODE_ENTERED';
export const MAP_DIFFICULTY_CHANGED = 'MAP_DIFFICULTY_CHANGED';
export const ENABLE_TERRAIN_EDITOR = 'ENABLE_TERRAIN_EDITOR';
export const DISABLE_TERRAIN_EDITOR = 'DISABLE_TERRAIN_EDITOR';
export const ADD_TERRAIN = 'ADD_TERRAIN';
export const SET_ACTIVE_TERRAIN = 'SET_ACTIVE_TERRAIN';


// WEBPACK FOOTER //
// ./src/app/actions.ts